(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer-discount"] && !Shopify.designMode) return;
  try {
    (function() {
    var form = document.querySelector('[data-cart-discount-form]');
    if (!form) return;

    var input = form.querySelector('#cart-drawer-discount-code');
    var message = document.getElementById('cart-drawer-discount-message');
    var button = form.querySelector('button[type="submit"]');
    var errorBlank = form.getAttribute('data-error-blank') || '';
    var applying = form.getAttribute('data-applying') || '';

    function setMessage(text, type) {
      if (!message) return;
      message.textContent = text || '';
      message.classList.remove('cart-drawer-discount__message--error', 'cart-drawer-discount__message--success');
      if (type === 'error') {
        message.classList.add('cart-drawer-discount__message--error');
      } else if (type === 'success') {
        message.classList.add('cart-drawer-discount__message--success');
      }
    }

    form.addEventListener('submit', function(event) {
      event.preventDefault();
      if (!input) return;

      var code = (input.value || '').trim();
      if (!code) {
        setMessage(errorBlank, 'error');
        input.focus();
        return;
      }

      if (button) {
        button.setAttribute('aria-busy', 'true');
        button.disabled = true;
      }

      setMessage(applying, 'success');

      var redirect = window.location.pathname === '/cart' ? '/cart' : '/checkout';
      var url = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(redirect);

      if (document.startViewTransition) {
        document.startViewTransition(function() {
          window.location.href = url;
        });
      } else {
        window.location.href = url;
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
